<!-- Logo Brixx -->
<!--<div (click)="goToMainSite()" class="new-logo-container"></div>-->
<sign-up-header></sign-up-header>
<!-- Container with success Email changed -->
<div *ngIf="isEmailChanged" class="email-changed-pane">
    <div [height]="15"></div>
    <div class="cnt-row">
        <div class="success-logo-container"></div>
        <div [width]="15"></div>
        <div class="b1Color p1Font">Success! Your email has been updated.</div>
    </div>
</div>

<!-- Main container Login -->
<div class="sign-in-pane" data-testid="winLogin">

    <!-- Header container -->
    <div class="cnt-column-centered">
        <div class="override-header-font header-font float-right b1Color" i18n>{{ 'LOG_IN_TO_YOUR' | translate }} {{isBusinessDoctors ? '' : 'Brixx'}} {{ 'ACCOUNT' | translate }}</div>
        <div>
            <span class="simple-font landing-font simple-font b1Color">
                <ng-container i18n="@@dontHaveAccount"> {{ 'DONOT_HAVE' | translate }} {{isBusinessDoctors ? 'an' : ' a Brixx'}} {{ 'ACCOUNT' | translate }}? - </ng-container>
                <a class="bottom-links simple-font o1Color" (click)="goToSignUp()" data-testid="resetPasswordSignInLink" i18n="@@signUpLink">{{ 'CREATE_ONE_HERE' | translate }}</a>
            </span>
        </div>
    </div>

    <!-- Basic container -->
    <div class="cnt-column-centered first-column-size">
        <!--<div [height]="10"></div>-->
        <!-- Input + btn container -->
        <div class="cnt-column-centered">

            <!-- Input container -->
            <div [style.width.px]="300">
                <div>
                    <!--<span class="h3Font" i18n>Email address</span>-->
                    <input #emailInput
                           id="email"
                           [(ngModel)]="newUser.email"
                           (focusout)="validateEmail()"
                           class="default-input"
                           type="email"
                           name="email"
                           i18n-placeholder
                           [placeholder]="'ENTER_EMAIL_ADDRESS' | translate"
                           autocomplete="off"
                           [height]="40"
                           maxlength="100"
                           tabindex="1"
                           data-testid="loginEmail-edit-input">
                    <div #emailWrongMsg class="validation-failed-message" id="loginEmail-edit-validityMark" data-testid="loginEmail-edit-validityMark">​</div>
                </div>
                <div>
                    <!--<span class="h3Font" i18n>Password</span>-->
                    <input #passwordInput 
                           id="password"
                           [(ngModel)]="newUser.passwordStr"
                           (focusout)="validatePassword()"
                           class="default-input"
                           type="password"
                           name="password"
                           i18n-placeholder
                           [placeholder]="'ENTER_YOUR_PASSWORD' | translate"
                           autocomplete="off"
                           [height]="40"
                           maxlength="48"
                           minlength="8"
                           tabindex="2"
                           data-testid="loginPassword-edit-input">
                    <div #passwordWrongMsg class="validation-failed-message" id="loginPassword-edit-validityMark" data-testid="loginPassword-edit-validityMark">​</div>
                    <div *ngIf="isLicenseNotActivatedError" class="cnt-column-centered">
                        <ng-container>{{ 'YOUR_EMAIL_IS_NOT' | translate }} - 
                            <span class="resendLink" (click) = "resendLink()">{{ 'RESEND_VALIDATION_LINK' | translate }}</span>
                        </ng-container>
                    </div>
                </div>
            </div>

            <!-- Btn container -->
            <div>
                <simple-btn class="signup-btn"
                            [hoverTextColor]="'white'"
                            [backgroundFillCls]="'o2Background'"
                            [hoverFillCls]="'o1Background'"
                            [boxShadowCls]="'primary-shadow'"
                            [text]="logInButtonText | translate"
                            [textCls]="'large-btn-text-500'"
                            [height]="40"
                            [width]="200"
                            [cornerRadius]="50"
                            [horizontalPadding]="20"
                            (click)="signIn()"
                            tabindex="3"
                            data-testid="winLoginSignInBtn">
                </simple-btn>
            </div>
        </div>

        <div [height]="10"></div>

        <div class="cnt-column-centered">
            <div class="cnt-row" style="align-items: center">
                <div class="small-separating-line"></div>
                <div class="separating-text-offset p1Font" i18n>{{ 'OR' | translate }}</div>
                <div class="small-separating-line"></div>
            </div>
        </div>

        <div [height]="10"></div>

        <!-- Alternative login container -->
        <div class="cnt-column-centered">
            <simple-btn #xeroSignUpBtn
                        class="signup-btn integration_button"
                        [text]="xeroLogInButtonText | translate"
                        [textCls]="'large-btn-text-500 m-auto'"
                        [height]="50"
                        [width]="310"
                        [cornerRadius]="16"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'sso-button-hover'"
                        [borderWidth]=2
                        [borderColorCls]="'xeroBorder'"
                        [hoverBorderColorCls]="'xeroBorder'"
                        [textColorCls]="'b1color'"
                        [hoverTextColorCls]="'b1color'"
                        [leftImgCls]="'xeroLogo-small m-left-10'"
                        (click)="integrationSignUp(integrationCompany.Xero)"
                        data-testid="xeroSignUpBtn"
                        [ignoreLeftSpace]="true">
            </simple-btn>

            <simple-btn #crunchSignInBtn
            						*ngIf="isCrunchButtonVisible"
                        class="integration_button"
                        [text]="crunchSignInButtonText | translate"
                        [textCls]="'large-btn-text-500 m-auto'"
                        [height]="50"
                        [width]="310"
                        [cornerRadius]="16"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'sso-button-hover'"
                        [borderWidth]=2
                        [borderColorCls]="'crunchBorderColor'"
                        [hoverBorderColorCls]="'crunchBorderColor'"
                        [textColorCls]="'b1color'"
                        [hoverTextColorCls]="'b1color'"
                        [leftImgCls]="'crunchLogo-small m-left-10'"
                        (click)="integrationSignUp(integrationCompany.Crunch)"
                        data-testid="crunchSignInBtn"
                        [ignoreLeftSpace]="true">
            </simple-btn>

            <simple-btn #googleLogInBtn
                        class="integration_button"
                        [text]="googleLogInButtonText | translate"
                        [textCls]="'large-btn-text-500 m-auto'"
                        [height]="50"
                        [width]="310"
                        [cornerRadius]="16"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'sso-button-hover'"
                        [borderWidth]=2
                        [borderColorCls]="'googleBorder'"
                        [hoverBorderColorCls]="'googleBorder'"
                        [textColorCls]="'b1color'"
                        [hoverTextColorCls]="'b1color'"
                        [leftImgCls]="'googleLogo-small m-left-10'"
                        (click)="integrationSignUp(integrationCompany.Google)"
                        data-testid="googleLogInBtn"
                        [ignoreLeftSpace]="true">
            </simple-btn>

            <simple-btn #facebookLogInBtn
                        class="integration_button"
                        [text]="facebookLogInButtonText | translate"
                        [textCls]="'large-btn-text-500 m-auto'"
                        [height]="50"
                        [width]="310"
                        [cornerRadius]="16"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'sso-button-hover'"
                        [borderWidth]=2
                        [borderColorCls]="'facebookBorder'"
                        [hoverBorderColorCls]="'facebookBorder'"
                        [textColorCls]="'b1color'"
                        [hoverTextColorCls]="'b1color'"
                        [leftImgCls]="'facebookLogo-small m-left-10'"
                        (click)="integrationSignUp(integrationCompany.Facebook)"
                        data-testid="facebookLogInBtn"
                        [ignoreLeftSpace]="true">
            </simple-btn>

            <simple-btn #appleLogInBtn
                        *ngIf="isAppleButtonVisible"
                        class="integration_button"
                        [text]="appleLogInButtonText | translate"
                        [textCls]="'large-btn-text-500 m-auto'"
                        [height]="50"
                        [width]="310"
                        [cornerRadius]="16"
                        [backgroundFillCls]="'transparent-background'"
                        [hoverFillCls]="'sso-button-hover'"
                        [borderWidth]=2
                        [borderColorCls]="'appleBorder'"
                        [hoverBorderColorCls]="'appleBorder'"
                        [textColorCls]="'b1color'"
                        [hoverTextColorCls]="'b1color'"
                        [leftImgCls]="'appleLogo-small m-left-10'"
                        (click)="integrationSignUp(integrationCompany.Apple)"
                        data-testid="appleLogInBtn"
                        [ignoreLeftSpace]="true">
            </simple-btn>
        </div>
    </div>

    <div class="cnt-column-centered">
        <div class="big-separating-line"></div>
    </div>

    <!-- Footer -->
    <div class="cnt-column-centered">
        <div class="cnt-row-centered" [style.justify-content]="'space-between'" [style.width.px]="340">
            <div>
                <a style="font-weight: 600; font-size: 14px" class="bottom-links forgotten-password-link-text o1Color" (click)="goToForgottenPassword()" data-testid="loginSublinkResetPassword" i18n>{{ 'FORGOTTEN_PASSWORD' | translate }} ? </a>
            </div>
            <div class="checkboxContainer b1Color">
                <input type="checkbox" (click)="toggleKeepSignedIn()" id="keepSigned" class="checkboxRight newsCheckBox">
                <label for="keepSigned" data-testid="keepSignedInCheckBox">
                    <span i18n>{{ 'KEEP_ME_LOGGED_IN' | translate }}</span>
                </label>
            </div>
        </div>
    </div>

</div>

<modal *ngIf="showModal" [title]="modalTitle" [text]="modalText" (onClose)="closePopup()"></modal>